import { Component, Input } from '@angular/core';
import {
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  FormControl,
} from '@angular/forms';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-recaptcha[formControl]',
  template:
    '<re-captcha [formControl]="formControl" siteKey="{{siteKey}}" (resolved)="onResolve($event)"></re-captcha>',
  styleUrls: ['./recaptcha.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: RecaptchaComponent,
      multi: true,
    },
  ],
})
export class RecaptchaComponent implements ControlValueAccessor {
  @Input() formControl: FormControl;

  siteKey = environment.recaptcha_api_string;

  onChange = (value: any) => {};

  onTouched = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(obj: any): void {
    if (this.formControl && obj && obj !== this.formControl.value) {
      this.formControl.setValue(obj, { emitEvent: false });
    }
  }

  onResolve(captchaResponse: string) {
    if (this.formControl.value !== captchaResponse) {
      this.formControl.setValue(captchaResponse, { emitEvent: false });
    }
  }
}
